import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    text: {
        fontSize: '20px',
        fontWeight: 500,
        lineHeight: '28px',
        textAlign: 'center',
        color: theme.palette.primary.main,
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        paddingRight: theme.spacing(2),
    },
    radio: {
        paddingLeft: theme.spacing(1),
        height: 32,
        paddingRight: theme.spacing(1),
        "& svg": {
            width: 32,
            height: 32
        }
    },
}))